{
  "deliver-50-gears": { "name": "Entrega 50 engranajes", "item": "gear", "amount": 50, "reward": 100 }
}
